import _ = require('underscore');
import { ITypedItemInfo } from '../models/resourceInfoParts';
import { ITypedItem } from '../ServerApi/types/resourceParts';
import { FeatureFlags } from '../FeatureFlags';
import { ILocationInfo, LocationTypes } from '../models/ILocationInfo';

export module LocationMapper {
  export function mapOne(l: ITypedItemInfo): ILocationInfo {
    return {
      type:        getLocationType(l.type),
      id:          l.id,
      name:        l.name,
      contents:    l.contents,
      luid:        l.luid,
      count:       l.count
    };
  }

  export function map(serverApiLocations: ITypedItem[]): ILocationInfo[] {
    if (FeatureFlags.personalSpaceEnabled) {
      return _.map(serverApiLocations, mapOne);
    }
    return [];
  }

  function getLocationType(type: string): LocationTypes {
    switch (type) {
      case 'PROJECT':
        return LocationTypes.Project;
      case 'PERSONAL_SPACE':
        return LocationTypes.PersonalSpace;
      default:
        return LocationTypes.Unknown;
    }
  }
}